<script setup lang="ts">
import VideoCard from './VideoCard.vue';
import type { VideoEntry } from '../types';
import { useVideoStore } from '../stores/videoStore';

const videoStore = useVideoStore();

defineProps<{
  videos: VideoEntry[];
}>();

const emit = defineEmits<{
  play: [id: string, name: string, segmented: boolean];
  delete: [id: string];
  select: [id: string];
}>();
</script>

<template>
  <div class="video-grid">
    <VideoCard
      v-for="video in videos"
      :key="video.id"
      :video="video"
      :selected="videoStore.selectedIds.has(video.id)"
      @play="(id) => emit('play', id, video.name, !!video.segmented)"
      @delete="emit('delete', $event)"
      @select="emit('select', $event)"
    />
  </div>
</template>

<style scoped>
.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  margin-bottom: 32px;
  width: 100%;
}

@media (max-width: 768px) {
  .video-grid {
    gap: 10px;
    padding: 0 16px;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    width: 100%;
  }
}

@media (max-width: 480px) {
  .video-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    padding: 0 12px;
    width: 100%;
  }
}
</style>
